// Claims Reporting Actions

import {
  UPDATE_CLAIMS_REPORTING_FIELDS,
  SAVE_CLAIMS_REPORT_PARAMETERS_REQUEST,
  SAVE_CLAIMS_REPORT_PARAMETERS_SUCCESS,
  SAVE_CLAIMS_REPORT_PARAMETERS_FAILURE,
  SAVE_CLAIMS_REPORT_PARAMETERS_LOADING,
  FETCH_SAVED_CLAIMS_REPORTS_REQUEST,
  FETCH_SAVED_CLAIMS_REPORTS_SUCCESS,
  FETCH_SAVED_CLAIMS_REPORTS_FAILURE,
  FETCH_SAVED_CLAIMS_REPORTS_LOADING,
  REMOVE_CLAIMS_REPORT_REQUEST,
  REMOVE_CLAIMS_REPORT_SUCCESS,
  REMOVE_CLAIMS_REPORT_FAILURE,
  REMOVE_CLAIMS_REPORT_LOADING,
  GENERATE_CONVERSATION_REQUEST,
  GENERATE_CONVERSATION_SUCCESS,
  GENERATE_CONVERSATION_FAILURE,
  GENERATE_CONVERSATION_LOADING,
  FETCH_SINGLE_CLAIMS_REPORT_REQUEST,
  FETCH_SINGLE_CLAIMS_REPORT_SUCCESS,
  FETCH_SINGLE_CLAIMS_REPORT_FAILURE,
  FETCH_SINGLE_CLAIMS_REPORT_LOADING,
  RESET_REPORT_STATE,
  RESET_REMOVE_REPORT_STATE,
  PRE_SELECT_TEMPLATE_FIELDS,
  EXPORT_REPORT_DATA_REQUEST,
  EXPORT_REPORT_DATA_SUCCESS,
  EXPORT_REPORT_DATA_FAILURE,
  EXPORT_REPORT_DATA_LOADING
} from '../actionTypes';

export const updateClaimsReportingFields = (field: string, value: any) => {
  return {
    type: UPDATE_CLAIMS_REPORTING_FIELDS,
    payload: {
      field,
      value,
    },
  };
};

export const fetchClaimsReportingData = (payload: any) => {
  return {
    type: FETCH_SAVED_CLAIMS_REPORTS_REQUEST,
    payload,
  };
};

export const fetchClaimsReportingDataSuccess = (payload: any) => {
  return {
    type: FETCH_SAVED_CLAIMS_REPORTS_SUCCESS,
    payload,
  };
};

export const fetchClaimsReportingDataFailure = (payload: any) => {
  return {
    type: FETCH_SAVED_CLAIMS_REPORTS_FAILURE,
    payload,
  };
};

export const fetchClaimsReportingDataLoading = (payload: any) => {
  return {
    type: FETCH_SAVED_CLAIMS_REPORTS_LOADING,
    payload,
  };
};

// Save Report Parameters Action

export const saveReportParameters = (payload: any) => {
  return {
    type: SAVE_CLAIMS_REPORT_PARAMETERS_REQUEST,
    payload,
  };
};

export const saveReportParametersSuccess = (payload: any) => {
  return {
    type: SAVE_CLAIMS_REPORT_PARAMETERS_SUCCESS,
    payload,
  };
};

export const saveReportParametersFailure = (payload: any) => {
  return {
    type: SAVE_CLAIMS_REPORT_PARAMETERS_FAILURE,
    payload,
  };
};

export const saveReportParametersLoading = (payload: any) => {
  return {
    type: SAVE_CLAIMS_REPORT_PARAMETERS_LOADING,
    payload,
  };
};

export const resetReportState = () => {
  return {
    type: RESET_REPORT_STATE,
  };
};

// Genereate Conversation Action

export const generateConversation = (payload: any) => {
  return {
    type: GENERATE_CONVERSATION_REQUEST,
    payload,
  };
};

export const generateConversationSuccess = (payload: any) => {
  return {
    type: GENERATE_CONVERSATION_SUCCESS,
    payload,
  };
};

export const generateConversationFailure = (payload: any) => {
  return {
    type: GENERATE_CONVERSATION_FAILURE,
    payload,
  };
};

export const generateConversationLoading = (payload: any) => {
  return {
    type: GENERATE_CONVERSATION_LOADING,
    payload,
  };
};

// Remove Report Action

export const removeReport = (payload: any) => {
  return {
    type: REMOVE_CLAIMS_REPORT_REQUEST,
    payload,
  };
};

export const removeReportSuccess = (payload: any) => {
  return {
    type: REMOVE_CLAIMS_REPORT_SUCCESS,
    payload,
  };
};

export const removeReportFailure = (payload: any) => {
  return {
    type: REMOVE_CLAIMS_REPORT_FAILURE,
    payload,
  };
};

export const removeReportLoading = (payload: any) => {
  return {
    type: REMOVE_CLAIMS_REPORT_LOADING,
    payload,
  };
};

export const resetRemoveReportState = () => {
  return {
    type: RESET_REMOVE_REPORT_STATE,
  };
};

// Fetch Single Claims Report with Report ID

export const fetchSingleClaimsReport = (payload: any) => {
  return {
    type: FETCH_SINGLE_CLAIMS_REPORT_REQUEST,
    payload,
  };
};

export const fetchSingleClaimsReportSuccess = (payload: any) => {
  return {
    type: FETCH_SINGLE_CLAIMS_REPORT_SUCCESS,
    payload,
  };
};

export const fetchSingleClaimsReportFailure = (payload: any) => {
  return {
    type: FETCH_SINGLE_CLAIMS_REPORT_FAILURE,
    payload,
  };
};

export const fetchSingleClaimsReportLoading = (payload: any) => {
  return {
    type: FETCH_SINGLE_CLAIMS_REPORT_LOADING,
    payload,
  };
};

export const preSelectTemplateField = (payload: any) => {
  return {
    type: PRE_SELECT_TEMPLATE_FIELDS,
    payload,
  };
};

// Export Report Data Action

export const exportReportData = (payload: any) => {
  return {
    type: EXPORT_REPORT_DATA_REQUEST,
    payload,
  };
};

export const exportReportDataSuccess = () => {
  return {
    type: EXPORT_REPORT_DATA_SUCCESS,
  };
};

export const exportReportDataFailure = () => {
  return {
    type: EXPORT_REPORT_DATA_FAILURE,
  };
};

export const exportReportDataLoading = (isLoading: boolean) => {
  return {
    type: EXPORT_REPORT_DATA_LOADING,
    payload: isLoading,
  };
};
